import { Typography } from 'antd'
import React from 'react'
import InputMenu from 'src/features/templateEdit/itemAppender/InputMenu'
import { SelectResponseTableCell } from 'src/features/templateEdit/itemAppender/ResponseDropDown/ResponseDropDown.dump'
import { White } from 'src/features/theme/KdsThemeColor'

const { Text } = Typography

type InputFormSectionProps = {
  onChangeQuestionType: (key: string) => void
  onCloseDropdown: () => void
}

export const InputFormSection: React.FC<InputFormSectionProps> = ({
  onChangeQuestionType,
  onCloseDropdown,
}) => {
  return (
    <SelectResponseTableCell
      theme={{ minWidth: '240px', backgroundColor: White }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          lineHeight: '40px',
          margin: '5px',
          height: '40px',
        }}
      >
        <Text style={{ marginRight: 'auto' }}>入力フォーム</Text>
      </div>
      <InputMenu
        onClick={key => {
          onChangeQuestionType(key)
          onCloseDropdown()
        }}
      />
    </SelectResponseTableCell>
  )
}
